import React from "react";
import Tooltip from "@mui/material/Tooltip";
import dsTokens from "../tokens";

/*
  Einmal gebaut, nicht pro Rendern: Die Werte sind ausschliesslich CSS-Variablen
  und haengen an keiner Prop. Als Objektliteral im Rumpf waeren sie bei jedem
  Rendern neu, und MUI serialisiert jedes neue sx-Objekt erneut — auf Seiten mit
  hunderten Tooltips (Monatsansicht der Verfuegbarkeit) ist das der teuerste
  Posten ueberhaupt.
*/
const TOOLTIP_SLOT_PROPS = {
  popper: {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, dsTokens.tooltip.offset],
        },
      },
    ],
    sx: {
      zIndex: "var(--ds-tooltip-z-index)",
    },
  },
  tooltip: {
    sx: {
      backgroundColor: "var(--ds-tooltip-bg)",
      color: "var(--ds-tooltip-text)",
      borderRadius: "var(--ds-tooltip-radius)",
      boxShadow: "var(--ds-tooltip-shadow)",
      maxWidth: "var(--ds-tooltip-max-width)",
      paddingInline: "var(--ds-tooltip-pad-inline)",
      paddingBlock: "var(--ds-tooltip-pad-block)",
      fontFamily: "var(--ds-font-family)",
      fontSize: "var(--ds-tooltip-font-size)",
      lineHeight: "var(--ds-tooltip-line-height)",
      fontWeight: "var(--ds-tooltip-font-weight)",
      margin: 0,
    },
  },
  arrow: {
    sx: {
      color: "var(--ds-tooltip-bg)",
      "&::before": {
        boxShadow: "var(--ds-tooltip-shadow)",
      },
    },
  },
};

const TOOLTIP_CHILD_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "middle",
};

export default function AppTooltip({
  content,
  placement = "top",
  disabled = false,
  enterDelay = dsTokens.tooltip.enterDelay,
  enterNextDelay = dsTokens.tooltip.enterNextDelay,
  leaveDelay = dsTokens.tooltip.leaveDelay,
  children,
  ...props
}) {
  if (!content || disabled) {
    return children;
  }

  const childIsDisabled = React.isValidElement(children) && Boolean(children.props.disabled);
  const normalizedChild =
    childIsDisabled && React.isValidElement(children)
      ? React.cloneElement(children, {
          style: {
            ...(children.props.style || {}),
            pointerEvents: "none",
          },
        })
      : children;

  return (
    <Tooltip
      title={content}
      placement={placement}
      arrow
      disableInteractive
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      leaveDelay={leaveDelay}
      slotProps={TOOLTIP_SLOT_PROPS}
      {...props}
    >
      <span style={TOOLTIP_CHILD_STYLE}>
        {normalizedChild}
      </span>
    </Tooltip>
  );
}
